var bookshelf = require("../index-extended");
require("./Building");
require("./Mandate");
require("./BuildingLot");

module.exports = bookshelf.model("BuildingOwner", {
  entityName: "BuildingOwner",
  entityTimestampable: true,
  entitySync: true,
  entityUuid: true,

  tableName: "building_owner",
  building() {
    return this.belongsTo("Building");
  },
  building_lots() {
    return this.belongsToMany(
      "BuildingLot",
      "building_owner_building_lot",
      "building_owner_id",
      "building_lot_id"
    );
  },
  // EX: one-to-many
  mandates() {
    return this.hasMany("Mandate", "building_owner_id");
  },

  format(attrs) {
    delete attrs["$id"];
    delete attrs["mandates"];
    delete attrs["building_lots"];
    delete attrs["building_owner_building_lots"];

    return attrs;
  },
});
